import { render, staticRenderFns } from "./ContentDetails.vue?vue&type=template&id=c7d9ead0&scoped=true&lang=pug&"
import script from "./ContentDetails.vue?vue&type=script&lang=js&"
export * from "./ContentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContentDetails.vue?vue&type=style&index=0&id=c7d9ead0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d9ead0",
  null
  
)

export default component.exports